module.exports = __webpack_public_path__ + "static/img/gitee.567691a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/content/gitee.svg
// module id = b17y
// module chunks = 1